import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class={{this.classNames}}></div>\n",{ moduleName: "sh-www/components/nav/status-unread-count.hbs" })